import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IInstructionalVideo,
  IInstructionalVideoCategory,
  INirlatConsultant,
  INirlatTips,
  IPaginationParams,
} from '@interfaces';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class NirlatConsultationService {
  constructor(private http: HttpClient) {}

  // Nirlat Consultant
  getAllNirlatConsultant(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-consultation/nirlat-consultant', { params });
  }

  exportNirlatConsultant(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(
      `/v1/admin/nirlat-consultation/nirlat-consultant/export`,
      filterData,
      options,
    );
  }

  updateNirlatConsultant(id: string, productData: INirlatConsultant) {
    return this.http.put(`/v1/admin/nirlat-consultation/nirlat-consultant/${id}`, productData);
  }

  createNirlatConsultant(productData: INirlatConsultant) {
    return this.http.post('/v1/admin/nirlat-consultation/nirlat-consultant', productData);
  }

  getNirlatConsultantById(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/nirlat-consultation/nirlat-consultant/${id}`);
  }

  deleteNirlatConsultant(id: string) {
    return this.http.delete(`/v1/admin/nirlat-consultation/nirlat-consultant/${id}`);
  }

  // Nirlat Tips

  getAllNirlatTips(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-consultation/nirlat-tips', { params });
  }

  exportNirlatTips(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/nirlat-consultation/nirlat-tips/export`, filterData, options);
  }

  updateNirlatTips(id: string, productData: INirlatTips) {
    return this.http.put(`/v1/admin/nirlat-consultation/nirlat-tips/${id}`, productData);
  }

  createNirlatTips(productData: INirlatTips) {
    return this.http.post('/v1/admin/nirlat-consultation/nirlat-tips', productData);
  }

  getNirlatTipsById(id: string) {
    return this.http.get(`/v1/admin/nirlat-consultation/nirlat-tips/${id}`);
  }

  deleteNirlatTips(id: string) {
    return this.http.delete(`/v1/admin/nirlat-consultation/nirlat-tips/${id}`);
  }

  updateNirlatTipsSequence(data: any) {
    return this.http.put(`/v1/admin/nirlat-consultation/nirlat-tips/updateSequence`, { data });
  }
  // Nirlat instructional video

  getAllInstructionalVideo(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-consultation/instructional-video', { params });
  }

  exportInstructionalVideo(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(
      `/v1/admin/nirlat-consultation/instructional-video/export`,
      filterData,
      options,
    );
  }

  updateInstructionalVideo(id: string, productData: IInstructionalVideo) {
    return this.http.put(`/v1/admin/nirlat-consultation/instructional-video/${id}`, productData);
  }

  createInstructionalVideo(productData: IInstructionalVideo) {
    return this.http.post('/v1/admin/nirlat-consultation/instructional-video', productData);
  }

  getInstructionalVideoById(id: string) {
    return this.http.get(`/v1/admin/nirlat-consultation/instructional-video/${id}`);
  }

  deleteInstructionalVideo(id: string) {
    return this.http.delete(`/v1/admin/nirlat-consultation/instructional-video/${id}`);
  }

  updateInstructionalVideoSequence(data: any) {
    return this.http.put(`/v1/admin/nirlat-consultation/instructional-video/updateSequence`, { data });
  }

  // Nirlat Instructional Video Categories

  getAllInstructionalCategory(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-consultation/instructional-categories', { params });
  }

  exportInstructionalCategory(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(
      `/v1/admin/nirlat-consultation/instructional-categories/export`,
      filterData,
      options,
    );
  }

  updateInstructionalCategory(id: string, productData: IInstructionalVideoCategory) {
    return this.http.put(`/v1/admin/nirlat-consultation/instructional-categories/${id}`, productData);
  }

  createInstructionalCategory(productData: IInstructionalVideoCategory) {
    return this.http.post('/v1/admin/nirlat-consultation/instructional-categories', productData);
  }

  getInstructionalCategoryById(id: string) {
    return this.http.get(`/v1/admin/nirlat-consultation/instructional-categories/${id}`);
  }

  deleteInstructionalCategory(id: string) {
    return this.http.delete(`/v1/admin/nirlat-consultation/instructional-categories/${id}`);
  }

  updateInstructionalCategorySequence(data: any) {
    return this.http.put(`/v1/admin/nirlat-consultation/instructional-categories/updateSequence`, { data });
  }
}
